import styled from 'styled-components';

const H3 = styled.h3`
  font-size: 1.125em;
`;

export default H3;



// WEBPACK FOOTER //
// ./client/components/shared/H3/index.js